<script>
	import { filtro_buscar, filtro_size } from '../store.js';
	export let handler = () => console.log("Unhandled action")
	
	let params = { texto:"", talle:[] }
	params.texto = $filtro_buscar
	params.talle = $filtro_size.replace(/'/g, '').split(",")
	
	let tipo_talle=0
	
	const elegir_por = idx => tipo_talle = idx

	$: talles_numero = () => ['24','26','28','30','32','34','36','38','40','42']
	$: talles_nombre = () => ['L','M','S','XS','XL','XXL']
	$: if (params.talle.length===0) tipo_talle = 0

	function aceptar(){
		filtro_buscar.set(params.texto)
		filtro_size.set("'"+params.talle.join("','")+"'")
		handler({response:0,view_dst:'catalogo'})
	}

	function cancelar(){
		handler({response:0,view_dst:'catalogo'})
	}

</script>

<!-- <div class="modal" on:click|self={()=>handler({ texto:"", talle:"" })}> -->
<div class="modal" on:click|self={cancelar}>
	<div class="card responsive-margin">
		<div class="section responsive-padding bg-gray-200">
			<br>
			<label for="">Ingrese texto a buscar</label>
			<input type="text" style="width: 94%;" placeholder="nombre, descripcion, ..." bind:value={params.texto}>
			<br>
			<br>
			<label for="">Filtrar por talles</label><br>
			{#await talles_numero()}
				<div class="spinner"></div>
			{:then rs}
			  {#if tipo_talle===0 || tipo_talle===1}
				<div class="h-center">
					{#each rs as item, index}
						<span class="v-center">
							<small>{item}</small><input type=checkbox bind:group={params.talle} value={item}  on:click={()=>elegir_por(1)}>
						</span>
					{/each}
				</div>
			  {/if}
			{/await}
			{#if tipo_talle===0}<hr>{/if}
			{#await talles_nombre()}
				<div class="spinner"></div>
			{:then rs}
			  {#if tipo_talle===0 || tipo_talle===2}
				<div class="h-center">
					{#each rs as item, index}
						<span class="v-center">
							<small>{item}</small><input type=checkbox bind:group={params.talle} value={item} on:click={()=>elegir_por(2)}>
						</span>
					{/each}
				</div>
			  {/if}
			{/await}

		</div>		
		<div class="section" style="text-align: right;">
			<button class="cancel" on:click={cancelar}>Cancel</button>
			<button class="ok" on:click={aceptar}>Ok</button>
		</div>
	</div>
</div>



